(function() {
    'use strict';

    angular
        .module('receiptApp')
        .controller('ReceiptSendPsDialogController', ReceiptSendPsDialogController);

    ReceiptSendPsDialogController.$inject = ['$scope', '$uibModalInstance','stepStr','numStep'];

    function ReceiptSendPsDialogController ($scope, $uibModalInstance,stepStr,numStep) {
    	var sendPsDlgCtr = this;
    	sendPsDlgCtr.confirm= confirm;
    	sendPsDlgCtr.stepStr = stepStr;
    	sendPsDlgCtr.numStep = numStep;
    	function confirm(numChoose) {
        	$uibModalInstance.close(numChoose);
        }
    }
})();
